import { Card } from "components/base/Card";
import { Title } from "components/base/Title";
import { Text } from "components/base/Text";
import { ImageBackground } from "components/ImageBackground";
import { Button } from "components/base/Button";
import { Input } from "components/base/Input";
import { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { resetPassword, ResetPasswordPayload } from "../services/apiAuth";
import { handleApiError } from "../utils/errorHandlers";
import { validatePassword } from "utils/utils";
import { ApiError } from "components/ApiError";

export const ResetPassword = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const { token } = useParams();
  const email = searchParams.get("email");

  const [errors, setErrors] = useState<Record<string, string[]>>({});

  const [formData, setFormData] = useState<{
    newPassword: string;
    confirmNewPassword: string;
  }>({
    newPassword: "",
    confirmNewPassword: "",
  });



  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (formData.newPassword !== formData.confirmNewPassword) {
      setErrors({
        password: ['Les mots de passe ne correspondent pas'],
      });
      return;
    }

    const validationErreur = validatePassword(formData.newPassword);
    if (validationErreur != null) {
      setErrors({
        password: [validationErreur]
      })
      return;
    }

    const payload: ResetPasswordPayload = {
      email: email ?? "",
      token: token ?? "",
      password: formData.newPassword,
      password_confirmation: formData.confirmNewPassword,
    }

    try {
      const response = await resetPassword(payload)
      setErrors({ "okAPI": [response.data?.status] })
    } catch (error: any) {
      const erreurBack = handleApiError(error);
      // Soit on reçoit du back une erreur général 
      // Soit c'est une erreur lié au champs (email est considéré comme un champs mais vu qu'il n'est pas visible passe en général)
      if (typeof erreurBack === "string") {
        setErrors({ general: [erreurBack] });
      } else {
        const emailError = Array.isArray(erreurBack?.email) && erreurBack.email.length > 0 ? erreurBack.email : [];
        const passwordError = Array.isArray(erreurBack?.password) && erreurBack.password.length > 0 ? erreurBack.password : [];
        setErrors({ general: emailError, password: passwordError })
      }
    }
  };

  return (
    <ImageBackground src="/bg-connexion.jpg" fullHeight filter="bg-secondary" opacity="opacity-40">
      <Card className="flex flex-col md:max-w-lg max-w-[calc(100%-2rem)] w-full shadow-sm shadow-primary-100 gap-6 my-8" p="px-6 py-8">
        <div>
          <Title type="subdisplay" centered>Nouveau mot de passe</Title>
          <Text centered className="text-gray-600">Renseignez votre nouveau mot de passe.</Text>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">

          <Input
            type="password"
            name="newPassword"
            label="Nouveau mot de passe"
            placeholder="Nouveau mot de passe"
            required
            width="100%"
            value={formData.newPassword}
            error={errors.password && errors.password[0]}
            onChange={handleChange}
          />

          <Input
            type="password"
            name="confirmNewPassword"
            label="Confirmer le nouveau mot de passe"
            placeholder="Confirmer le nouveau mot de passe"
            required
            width="100%"
            value={formData.confirmNewPassword}
            onChange={handleChange}
          />

          {errors.okAPI &&
            <div className="bg-success-100 border border-success-400 rounded px-3 py-2">
              {errors.okAPI[0]}
            </div>
          }

          {errors.general &&
            <ApiError>{errors.general[0]}</ApiError>
          }

          <div className="flex justify-center">
            <Button type="submit">Réinitialiser le mot de passe</Button>
          </div>
        </form>
        <div className="flex sm:flex-row flex-col justify-center items-center gap-2 w-[calc(100%+3rem)] bg-gray-200 p-4 -mx-6 -mb-8 rounded-b-2xl">
          <button className="text-primary-600 hover:text-primary-800 hover:underline"
            onClick={() => navigate('/connexion')}>
            Retour à la connexion
          </button>
        </div>
      </Card>
    </ImageBackground>
  );
};